module.exports = __webpack_public_path__ + "img/3.48e7bbdc.jpg";